import Loader from 'react-loader-advanced'
import React from 'react'
import ResponsiveTable from '../../Table/ResponsiveTable.js'
import flatten from 'lodash/flatten'
import { getDownloadAttachmentByAutoprocAttachmentId } from '../../../api/ispyb.js'

export default class AutoProcProgramAttachentList extends React.Component {
  getFileNameFormatter(cell, row, rowIndex, extradata) {
    if (cell !== null) {
      return (
        <a
          target="_blank"
          rel="noreferrer"
          href={getDownloadAttachmentByAutoprocAttachmentId(
            extradata.props.user,
            extradata.props.proposal,
            row.autoProcProgramAttachmentId
          )}
        >
          {cell}
        </a>
      )
    }
    return null
  }

  getColumns() {
    return [
      {
        text: 'autoProcProgramAttachmentId',
        dataField: 'autoProcProgramAttachmentId',
        hidden: true,
      },
      {
        text: 'Attachments',
        dataField: 'fileName',
        formatter: this.getFileNameFormatter,
        formatExtraData: this,
      },
    ]
  }

  render() {
    if (this.props.data.length === 0) {
      return null
    }
    return (
      <Loader show={this.props.fetching}>
        <ResponsiveTable
          pageOptions={{
            sizePerPage: 25,
          }}
          search={false}
          keyField="autoProcProgramAttachmentId"
          data={flatten(this.props.data)}
          columns={this.getColumns()}
        />
      </Loader>
    )
  }
}
